import {
  LinksExchangeShowCreateResultParams,
  linksYoroiModuleMaker,
} from '@yoroi/links'
import {Exchange, Links} from '@yoroi/types'
import {PartnerInfoType} from 'common/partner-info'

export const orderShowCreateResult = ({
  scheme,
  provider,
  orderType,
  partnerInfo,
  coin,
  coinAmount,
  fiat,
  fiatAmount,
  status,
}: {
  scheme: Links.YoroiUriConfig['scheme']
  provider: LinksExchangeShowCreateResultParams['provider']
  orderType: Exchange.OrderType
  partnerInfo: PartnerInfoType
  coin?: LinksExchangeShowCreateResultParams['coin']
  coinAmount?: LinksExchangeShowCreateResultParams['coinAmount']
  fiat?: LinksExchangeShowCreateResultParams['fiat']
  fiatAmount?: LinksExchangeShowCreateResultParams['fiatAmount']
  status?: LinksExchangeShowCreateResultParams['status'] | ''
}) => {
  try {
    const {exchange} = linksYoroiModuleMaker(scheme)

    const link = exchange.order.showCreateResult({
      provider,
      orderType,
      ...(fiat ? {fiat} : {}),
      ...(status ? {status} : {}),
      ...(coin ? {coin} : {}),
      ...(coinAmount ? {coinAmount} : {}),
      ...(fiatAmount ? {fiatAmount} : {}),
      ...partnerInfo,
    })

    return {link, error: null}
  } catch (e: any) {
    return {error: e.message, link: null}
  }
}
